module.exports = __webpack_public_path__ + "img/pipelining_inspection.b149ea07.png";